import { InputType } from "zlib";
import { ColorCode, NullableNumber, NullableString } from "../core/common_types";
import { CategoryCode } from "./category";
import { InstallationType, LatoInstallation } from "../routes/configurations/pergola/builder/components/forms/Pergola_type";
import { Option } from "./door_configuration";

export interface OverlapConfiguration {

}

export interface PergolaConfiguration extends OverlapConfiguration {
    categoryCode: CategoryCode,
    categoryId: number,
    configurationId: number,
    dimensioni: DimensionPergola,
    aspetto: AspectPergola,
    illuminazioneLed: any[],
    tipo_pergola: string,
}
export enum IlluminationType{
  led_freddo= "led_freddo",
  led_caldo= "led_caldo",
  led_rgb= "led_rgb",
  nessuno= "nessuno",
  faretto= "faretto",
}
export enum FarettoType{
  faretto_freddo= "faretto_freddo",
  faretto_caldo= "faretto_caldo",
  nessuno = "nessuno"
}
export type LatoType = {
  tipologia: VetrateType | TendeType | NoTypeSide
}
export type Optional = {
  sku: string;
  notes?: string;
  costo?: number;
};

export enum ChiusuraType {
    vetrate_ad_impacchettamento_andromeda = "vetrate_ad_impacchettamento_andromeda",
    vetrate_scorrevoli_maia = "vetrate_scorrevoli_maia",
    tende_zip = "tende_zip",
    nessuna = 'nessuna'
}
export enum VetroType {
    vetro_temperato_10mm = "vetro_temperato_10mm",
    vetro_camera_25mm_6_16_6_be = "vetro_camera_25mm_6_16_6_be"
}
export enum TeloType {
    teloCristal = "teloCristal",
    teloSemioscurantePVC = "teloSemioscurantePVC",
    teloSemioscurantePOLI = "teloSemioscurantePOLI",
    teloOscurantePOLI = "teloOscurantePOLI"
}
export enum Aperture {
  laterale = "laterale",
  centrale = "centrale"
}
export enum Verso {
  destra = "Destra",
  sinistra = "Sinistra",
  ambe = "Destra e Sinistra"
}
export enum VersoImpacchettamento {
  interna = "Interna",
  esterna = "Esterna"
}
export enum Fioriera {
  nessuna = "nessuna",
  fioriera_500x500mm = "fioriera_500x500mm",
  fioriera_807 = "fioriera_807"
}
export type VetrateType = {
    tipo_chiusura: ChiusuraType,
    tipo_vetro: VetroType,
    sistema_chiusura?: string,
    accessori: Optional[],
    apertura: Aperture,
    verso?: Verso,
    verso_impacchettamento?: VersoImpacchettamento,
    vie?: number
}
export type NoTypeSide = {
  tipo_chiusura: ChiusuraType,
}
export type TendeType = {
  tipo_chiusura: ChiusuraType,
  tipo_telo: TeloType,
  codice_telo: string,
  accessori: Optional[],
}

export type Chiusura = {
  code: string;
  img: string;
  name: string;
  price: number;
  tipo?: string;
};
export interface Telo {
  code: string;       
  img?: string;       
  tipo: string;
}
export type Accessorio = {
    id: number,
    sku: string,
    name: NullableString,
    price: number,
    um: NullableString,
    img: NullableString,
    qtyMax: number,
    inputType: InputType
} | null | undefined;

export type LatoIlluminazioneFaretto = { 
  numero: number;
  tipo: FarettoType 
};

export type TendaZipAccesories = {
    accessoriVari: Accessorio[],
}

export type EmailRilievo = {
  quoteNumber: number;
  referente: string;
  email: string;
  telefono: string;
  note?: string;
};

export type DimensionPergola = {
  quantita: number,
  altezza: number,
  profondita: number,
  larghezza: number,
  installazione: InstallationType,
  lati?: LatoSide[]
}
export type LatoSide = {
  direzione: "Retro" | "Fronte" | "Destra" | "Sinistra";
  tipo: LatoInstallation
}
export type DimensionPergolaLoad = {
  configurationId: number,
  quantita: number,
  altezza: number,
  profondita: number,
  larghezza: number,
  installazione: InstallationType,
  categoryId: number,
  categoryCode: CategoryCode,
  coloreInterno: NullableNumber,
  coloreEsterno: NullableNumber,
  isFinito: boolean,
  lati?: LatoSide[]
}
export type AspectPergola = {
  colore_telaio: NullableString,
  colore_lamelle: NullableString,
}

export type MuroPergola = {
   direzione: "Retro" | "Fronte" | "Destra" | "Sinistra";
   altezza: number
}


export type Pilastri = {
   direzione: "H1" | "H2" | "H3" | "H4";
   altezza: number
}

export type Fioriere ={
  direzione: string;
  tipo: Fioriera
}

export type Tubolare = {
   direzione: "Retro" | "Fronte" | "Destra" | "Sinistra" | "Retro2" | "Fronte2" | "Destra2" | "Sinistra2";
   numero: number
}

export type Rilievo = {
    notes: string;
    referente: string;
    email: string;
    telefono: string;
}